// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1288":"287c57f8","2801":"f9de0770"}[chunkId] + ".chunk.css";
};